(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-private-reward"]) return;
  try {
    
  (() => {
    function initReward(root) {
      if (root.dataset.initialized) return;
      const editor = root.dataset.editor === 'true';
      const draft = ['unpublished', 'development'].includes(window.Shopify?.theme?.role);
      const requested = new URLSearchParams(location.search).get('vg_reward_preview') === '1';
      if (root.dataset.enabled !== 'true' && !editor && !(draft && requested)) return;
      root.dataset.initialized = 'true';
      const dialog = root.querySelector('dialog');
      if (!dialog?.showModal) return;
      const teaser = root.querySelector('[data-reward-open]');
      const before = root.querySelector('[data-reward-unrevealed]');
      const after = root.querySelector('[data-reward-revealed]');
      const expired = root.querySelector('[data-reward-expired]');
      const status = root.querySelector('[data-reward-status]');
      const card = root.querySelector('[data-reward-card]');
      const prize = root.querySelector('[data-reward-prize]');
      const canvas = root.querySelector('[data-reward-scratch]');
      const applyButton = root.querySelector('[data-reward-apply]');
      const applyLabel = applyButton.innerHTML;
      root.querySelector('[data-reward-preview]').hidden = !draft && !editor;
      const key = 'vg:' + root.dataset.campaign;
      const repeatAfter = 3600000;
      let timer, focusBefore, state = {};
      function read() {
        try { const saved = JSON.parse(localStorage.getItem(key) || '{}'); return saved && typeof saved === 'object' ? saved : {}; } catch { return {}; }
      }
      function write(next) {
        try { localStorage.setItem(key, JSON.stringify(next)); state = next; return true; } catch { status.textContent = status.dataset.storageMessage; return false; }
      }
      function render() {
        const hasReveal = Number.isFinite(state.revealedAt) && Number.isFinite(state.expiresAt);
        const remaining = hasReveal ? Math.max(0, Math.ceil((state.expiresAt - Date.now()) / 1000)) : 0;
        before.hidden = hasReveal;
        after.hidden = !hasReveal || remaining === 0;
        expired.hidden = !hasReveal || remaining > 0;
        card.hidden = hasReveal && remaining === 0;
        card.dataset.unlocked = String(hasReveal);
        prize.setAttribute('aria-hidden', String(!hasReveal));
        teaser.hidden = dialog.open || (!state.dismissed && !hasReveal) || (hasReveal && remaining === 0);
        if (state.applied) { applyButton.disabled = true; applyButton.textContent = status.dataset.appliedLabel; }
        root.querySelector('[data-reward-clock]').textContent = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
        if (hasReveal && remaining === 0) { clearInterval(timer); if (dialog.open) dialog.close(); }
      }
      function open() {
        if (dialog.open) return;
        focusBefore = document.activeElement;
        status.textContent = '';
        state = read();
        const lastShown = Number(state.lastShownAt || state.seenAt || 0);
        if (lastShown && Date.now() - lastShown >= repeatAfter) state = {};
        if (Number.isFinite(state.expiresAt) && state.expiresAt <= Date.now()) return;
        dialog.showModal();
        write({ ...state, seenAt: state.seenAt || Date.now(), lastShownAt: Date.now() });
        applyButton.disabled = Boolean(state.applied);
        if (!state.applied) applyButton.innerHTML = applyLabel;
        render();
        clearInterval(timer);
        timer = setInterval(render, 1000);
      }
      root.hidden = false;
      state = read();
      root.querySelectorAll('[data-reward-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      teaser.addEventListener('click', open);
      dialog.addEventListener('click', event => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        clearInterval(timer);
        write({ ...read(), dismissed: true });
        render();
        if (focusBefore instanceof HTMLElement && focusBefore.isConnected) focusBefore.focus();
      });
      function revealReward(moveFocus = false) {
        state = read();
        if (!Number.isFinite(state.expiresAt)) {
          const now = Date.now();
          if (!write({ ...state, revealedAt: now, expiresAt: now + 3600000 })) return;
        }
        render();
        if (moveFocus) (after.hidden ? root.querySelector('[data-reward-close]') : root.querySelector('[data-reward-apply]')).focus();
      }
      root.querySelector('[data-reward-reveal]').addEventListener('click', () => revealReward(true));
      const ink = canvas.getContext('2d');
      const mask = document.createElement('canvas');
      mask.width = 100;
      mask.height = 62;
      const coverage = mask.getContext('2d', { willReadFrequently: true });
      if (ink && coverage) {
        ink.fillStyle = '#413123';
        ink.fillRect(0, 0, canvas.width, canvas.height);
        ink.fillStyle = '#d8c6a5';
        ink.font = 'italic 70px Georgia';
        ink.textAlign = 'center';
        ink.fillText('Valentier', 500, 305);
        coverage.fillRect(0, 0, 100, 62);
        let ready = false, activePointer = null, previous = null;
        const image = new Image();
        image.onload = () => {
          ink.globalCompositeOperation = 'source-over';
          ink.drawImage(image, image.naturalWidth * .103, image.naturalHeight * .306, image.naturalWidth * .794, image.naturalHeight * .390, 0, 0, 1000, 618);
          ready = true;
        };
        image.onerror = () => { ready = true; };
        if (canvas.dataset.image) image.src = canvas.dataset.image;
        else ready = true;
        function point(event) {
          const bounds = canvas.getBoundingClientRect();
          return { x: (event.clientX - bounds.left) / bounds.width * 1000, y: (event.clientY - bounds.top) / bounds.height * 618, radius: (event.pointerType === 'touch' ? 26 : 20) / bounds.width * 1000 };
        }
        function erase(event) {
          const next = point(event);
          for (const [context, scale] of [[ink, 1], [coverage, .1]]) {
            context.globalCompositeOperation = 'destination-out';
            context.lineCap = 'round';
            context.lineJoin = 'round';
            context.lineWidth = next.radius * 2 * scale;
            context.beginPath();
            context.moveTo((previous || next).x * scale, (previous || next).y * scale);
            context.lineTo(next.x * scale, next.y * scale);
            context.stroke();
            context.beginPath();
            context.arc(next.x * scale, next.y * scale, next.radius * scale, 0, Math.PI * 2);
            context.fill();
          }
          previous = next;
          const pixels = coverage.getImageData(0, 0, 100, 62).data;
          let erased = 0;
          for (let i = 3; i < pixels.length; i += 4) if (pixels[i] < 128) erased++;
          if (erased / 6200 >= .4) {
            activePointer = null;
            previous = null;
            revealReward();
          }
        }
        canvas.addEventListener('pointerdown', event => {
          if (!ready || Number.isFinite(state.expiresAt) || activePointer !== null || event.button !== 0) return;
          event.preventDefault();
          activePointer = event.pointerId;
          previous = null;
          canvas.setPointerCapture(event.pointerId);
          erase(event);
        });
        canvas.addEventListener('pointermove', event => {
          if (activePointer !== event.pointerId) return;
          event.preventDefault();
          erase(event);
        });
        function release(event) {
          if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
          activePointer = null;
          previous = null;
        }
        canvas.addEventListener('pointerup', release);
        canvas.addEventListener('pointercancel', release);
        canvas.addEventListener('lostpointercapture', release);
      }
      applyButton.addEventListener('click', async () => {
        state = read();
        render();
        if (after.hidden || state.applied) return;
        applyButton.disabled = true;
        applyButton.textContent = status.dataset.applyingLabel;
        status.textContent = '';
        try {
          const route = window.Shopify?.routes?.root || '/';
          const cartResponse = await fetch(route + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (!cartResponse.ok) throw new Error('cart');
          const cart = await cartResponse.json();
          const existing = (cart.discount_codes || []).map(discount => discount.code);
          const wanted = root.dataset.codes.split(',');
          const codes = [...new Set([...existing, ...wanted])];
          const response = await fetch(route + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
          if (!response.ok) throw new Error('update');
          const updated = await response.json();
          const rejected = updated.item_count > 0 && updated.discount_codes?.some(discount => discount.code.toUpperCase() === wanted[0] && discount.applicable === false);
          try {
            const { DiscountUpdateEvent } = await import('@theme/events');
            document.dispatchEvent(new DiscountUpdateEvent(updated, 'private-reward'));
          } catch { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: updated, source: 'private-reward', data: { itemCount: updated.item_count } } })); }
          if (rejected) { status.textContent = status.dataset.conflictMessage; return; }
          write({ ...read(), applied: true });
          status.textContent = status.dataset.checkoutMessage;
          render();
        } catch { status.textContent = status.dataset.errorMessage; }
        finally {
          if (!state.applied) { applyButton.disabled = false; applyButton.innerHTML = applyLabel; }
        }
      });
      window.addEventListener('storage', event => { if (event.key === key) { state = read(); render(); } });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { state = read(); render(); } });
      render();
      if (editor || (draft && requested)) open();
      else if (!Number(state.lastShownAt || state.seenAt || 0) || Date.now() - Number(state.lastShownAt || state.seenAt || 0) >= repeatAfter) {
        function offerWhenClear() {
          state = read();
          const lastShown = Number(state.lastShownAt || state.seenAt || 0);
          if (lastShown && Date.now() - lastShown < repeatAfter) return;
          const modalOpen = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some(modal => {
            if (modal.closest('[hidden], [inert], [aria-hidden="true"], details:not([open])')) return false;
            const style = getComputedStyle(modal);
            return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && modal.getClientRects().length > 0;
          });
          if (document.hidden || modalOpen) { setTimeout(offerWhenClear, 1000); return; }
          open();
        }
        offerWhenClear();
      }
    }
    document.querySelectorAll('[data-private-reward]').forEach(initReward);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-private-reward]').forEach(initReward));
  })();

  } catch(e) { console.error(e); }
})();
})();
